import * as React from 'react';
import * as style from './style.css';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

interface IGkCardLayoutProps {
  onHover(hovered: boolean): void;
  onShow(): void;
}

export const GkCardLayout: React.FC<React.PropsWithChildren<IGkCardLayoutProps>> = ({ children, onHover, onShow }) => {
  const handleMouseEnter = React.useCallback(() => {
    onHover(true);
  }, [onHover]);

  const handleMouseLeave = React.useCallback(() => {
    onHover(false);
  }, [onHover]);

  return (
    <ActionAfterViewObserver
      callback={onShow}
      triggerOnce={true}
      wrapper={false}
      percentVisible={0.5}
      callbackDelay={1000}
    >
      <div
        data-name="GKCardComponent"
        className={style['layout']}
        data-testid="GKCard"
        data-mark="GKCard"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </div>
    </ActionAfterViewObserver>
  );
};
